import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import ExternalLink from '@factorialco/f0-react/icons/app/ExternalLink'

import i18n from 'modules/core/lib/i18n'

const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mov', '.ogv', '.ogg']

function isVideoUrl(url: string): boolean {
  try {
    const pathname = new URL(url, 'https://dummy').pathname.toLowerCase()
    return VIDEO_EXTENSIONS.some((ext) => pathname.endsWith(ext))
  } catch {
    return false
  }
}

interface ProductDemoCardProps {
  /** URL to the product demo media (video or image). */
  navatticImageUrl: string
  /** When provided, uses this instead of inferring from URL. */
  mediaType?: 'video' | 'image'
  onProductDemo: () => void
}

const mediaStyle: React.CSSProperties = {
  width: '90px',
  height: '50px',
  borderRadius: '8px',
  objectFit: 'cover',
  flexShrink: 0,
}

export const ProductDemoCard = ({
  navatticImageUrl,
  mediaType,
  onProductDemo,
}: ProductDemoCardProps) => {
  const isVideo = mediaType === 'video' || (mediaType !== 'image' && isVideoUrl(navatticImageUrl))

  return (
    <Box paddingTop="s12" paddingX="s12">
      <div
        role="button"
        tabIndex={0}
        onClick={onProductDemo}
        onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onProductDemo()
          }
        }}
        style={{
          width: '100%',
          cursor: 'pointer',
          paddingTop: '6px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          gap: '12px',
        }}
      >
        {isVideo ? (
          <video
            src={navatticImageUrl}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            style={mediaStyle}
          />
        ) : (
          <img src={navatticImageUrl} alt="" style={mediaStyle} />
        )}
        <Box flexDirection="column" style={{ minWidth: '0', flex: '1' }}>
          <Box flexDirection="row" alignItems="center" gap="s2">
            <Text.Normal size="100" color="black" weight="medium">
              {i18n.t('growth.product_modal_extended.product_demo')}
            </Text.Normal>
            <ExternalLink width="14" height="14" style={{ flexShrink: '0' }} />
          </Box>
          <Text.Normal size="100" color="grey700">
            {i18n.t('growth.product_modal_extended.product_demo_description')}
          </Text.Normal>
        </Box>
      </div>
    </Box>
  )
}
